module.exports = __webpack_public_path__ + "static/media/2012.d78d8130.jpg";